import React from 'react';
import withView from '../../../docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';

const ProfileSearchBatchAction = (props) => {
    const { formObject, selectedDids, reloadSearch } = props;

    // const onActionSuccess = () => {
    //     if(reloadSearch)reloadSearch(1);
    // }

    const onPopupClose = () => {
        if(reloadSearch)reloadSearch(1);
    }

    return (
        <div className="uiFlexBox3">
            <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                starIcon="adds"
                action={{ actionId: "new",  actionMessage: "Processing Action", actionName: "invcomp", 
                actionParam: { showModeID: 'sh', tdtId: "303", viewCaller: 'profile', dIds:selectedDids.join(",") }, containerKey:"redirect" }}
                text={<SarasTrans value="Create Order" />}>
            </FormButton>
            <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                starIcon="adds"
                action={{ actionId: "new",  actionMessage: "Processing Action", actionName: "taskComp", 
                actionParam: { showModeID: 'sh', tdtId: "7011", viewCaller: 'profile', dIds:selectedDids.join(",") }, containerKey:"popup", onModalClose:onPopupClose }}
                text={<SarasTrans value="Create Lead" />}>
            </FormButton>
        </div >
    )
}

export default withView(ProfileSearchBatchAction, "", "", 1);